// Swiper settings for .di-slider

// docs: https://swiperjs.com/api/
import { Swiper, Navigation, Scrollbar, Pagination } from "swiper";
import "swiper/css";

Swiper.use([Navigation, Scrollbar, Pagination]);

window.swiperInstances = window.swiperInstances || [];

window.addEventListener("DOMContentLoaded", function () {
	const swiperArgs = () => {
		return {
			speed: 100,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			slidesPerView: 'auto',
			wrapperClass: "swiper-wrapper",
			grabCursor: true,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
			spaceBetween: 16,
            navigation: {
                prevEl: `.swiper-buttons__button--prev`,
                nextEl: `.swiper-buttons__button--next`,
                disabledClass: "swiper-buttons__button--disabled",
            }
		}

	}

	let swiperEls = document.querySelectorAll(".swiper.di-slider");
	for(let i = 0; i < swiperEls.length; i++) {
		window.swiperInstances[i] = new Swiper(swiperEls[i], swiperArgs())
	}
});


